import { createUseStyles } from 'react-jss'

export const NAVBAR_WIDTH = 54

export const style = {
  layout: {
    composes: 'body-text',
    display: 'grid',
    gridTemplateColumns: `${NAVBAR_WIDTH}px 1fr`,
    gridTemplateRows: '1fr',
    height: '100vh'
  }
}

export const useStyles = createUseStyles(style)
